import React from "react";
import instagramIcon from "../assets/images/instagram-icon.png";

const Footer = () => {
  return (
    <footer className="py-2">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-sm-7">
            <p>All Rights Reserved by TinyViva.org - 2025.</p>
          </div>
          <div className="col-12 col-sm-5 text-end">
            <a
              href="https://www.instagram.com/tinyviva.kids"
              target="_blank"
              className="instagram-link"
              rel="noreferrer"
            >
              <img src={instagramIcon} alt="Instagram Icon" />
            </a>
            <a href="/disclaimer">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
